import styled from "styled-components";

export const StyledOrdersList = styled.div`
  min-height: 100vh;
  background: var(--rms-v2-section-bg);
  color: var(--rms-v2-text-title);
  padding-bottom: 132px;
  margin: 0;

  .orders-shell {
    width: 100%;
    max-width: 500px;
    min-height: 100vh;
    margin: 0 auto;
  }

  .orders-content {
    padding: 10px 18px 28px;
  }

  .single-request-notice {
    margin: 12px 0 16px;
    padding: 12px 14px;
    border: 1px solid #f59e0b;
    border-left: 5px solid #d97706;
    background: #fffbeb;
    color: #78350f;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
  }

  .search-shell {
    margin: 0 -17px 8px;
    padding: 10px 12px;
    background: transparent;
    position: sticky;
    top: 60px;
    z-index: 999;
    border-bottom: 1px solid transparent;
    transition:
      background-color 160ms ease,
      border-color 160ms ease,
      box-shadow 160ms ease;
  }

  .search-shell.is-stuck {
    background: rgba(255, 255, 255);
    border-bottom-color: transparent;
    border-radius: 0 0 14px 14px;
    box-shadow: 0 10px 24px rgba(29, 42, 64, 0.08);
    backdrop-filter: blur(10px);
  }

  .search-field {
    height: 40px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 16px;
    margin: 0;
    background: var(--rms-v2-surface);
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    box-shadow: none;
  }

  .search-field svg {
    flex: 0 0 auto;
    color: var(--rms-v2-text-muted);
    font-size: 21px;
  }

  .search-field input {
    width: 100%;
    min-width: 0;
    border: 0;
    outline: 0;
    background: transparent;
    color: var(--rms-v2-text-title);
    font-size: 15px;
  }

  .search-field input::placeholder {
    color: var(--rms-v2-text-muted);
  }

  .orders-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .order-card {
    position: relative;
    width: 100%;
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    background: var(--rms-v2-surface);
    padding: 18px 18px 14px;
    color: inherit;
    text-align: left;
    cursor: pointer;
    box-shadow: none;
  }

  .order-card:disabled {
    cursor: not-allowed;
  }

  .order-card.trackable {
    border-color: ${(props) => props.primaryColor};
    margin-bottom: 14px;
  }

  .order-card-header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
  }

  .order-number {
    margin: 0;
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 1.2px;
    text-transform: uppercase;
  }

  .order-main {
    min-width: 0;
  }

  .order-dates {
    margin-top: 4px;
    color: var(--rms-v2-text-muted);
    font-size: 11px;
    font-weight: 500;
    text-transform: math-auto;
  }

  .order-meta {
    text-align: right;
    color: var(--rms-v2-text-muted);
    font-size: 11px;
  }

  .order-price {
    margin-top: 0;
    color: var(--rms-v2-text-title);
    font-size: 16px;
    font-weight: 900;
  }

  .order-count {
    margin-top: 3px;
    color: var(--rms-v2-text-title);
    font-size: 11px;
    font-weight: 700;
  }

  .order-images {
    display: flex;
    align-items: center;
    min-height: 74px;
    margin-top: 22px;
  }

  .order-image-wrap {
    position: relative;
    width: 68px;
    height: 68px;
    margin-right: -2px;
    overflow: hidden;
    background: #f5f7fa;
    border: 1px solid #dce4ef;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
  }

  .order-image-wrap img,
  .order-image-wrap .lazy-load-image-background,
  .order-image-wrap .lazy-load-image-loaded {
    width: 100%;
    height: 100%;
  }

  .order-image-wrap img {
    object-fit: cover;
    display: block;
  }

  .order-image-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--rms-v2-surface);
    font-size: 15px;
    font-weight: 900;
    background: rgba(37, 44, 54, 0.58);
    letter-spacing: 0.2px;
  }

  .order-divider {
    height: 1px;
    background: var(--rms-v2-border-soft);
    margin: 16px 0 12px;
  }

  .order-footer {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
  }

  .eligibility {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    text-transform: math-auto;
  }

  .eligibility-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .eligibility.eligible {
    color: var(--rms-v2-text-title);
  }

  .eligibility.trackable {
    color: var(--rms-v2-text-title);
  }

  .eligibility svg {
    flex: 0 0 auto;
    font-size: 17px;
  }
  
  .eligibility.eligible svg {
    fill: var(--rms-v2-success);
  }

  .view-order {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    color: ${(props) => props.primaryColor};
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  .view-order svg {
    font-size: 15px;
  }

  .order-card.trackable .view-order {
    position: absolute;
    right: 18px;
    bottom: -15px;
    z-index: 2;
    padding: 7px 10px;
    border-radius: 999px;
    background: ${(props) => props.primaryColor};
    color: var(--rms-v2-surface);
    box-shadow: 0 8px 18px rgba(29, 42, 64, 0.16);
  }

  .empty-state {
    margin-top: 32px;
    padding: 28px 18px;
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    background: var(--rms-v2-surface);
    color: var(--rms-v2-text-muted);
    text-align: center;
    font-size: 14px;
  }

  `;
